import React, { Component } from 'react';

import classnames from 'classnames';
import Button from 'shared/components/Button';
import styles from './styles.module.scss';

class LoadMoreView extends Component {
  state = {
    loadingMore: false
  };

  static getDerivedStateFromProps(props, state) {
    if (!props.isLoading && state.loadingMore) {
      return { loadingMore: false };
    }

    return null;
  }

  loadMore = () => {
    this.setState({ loadingMore: true });
    this.props.loadMore();
  };

  render() {
    const {
      hasMore,
      loader,
      children,
      isLoading,
      btnContainerClassname
    } = this.props;

    return (
      <React.Fragment>
        {isLoading && !this.state.loadingMore ? loader : children}
        {hasMore &&
          !isLoading && (
            <div
              className={classnames(
                styles.buttonContainer,
                btnContainerClassname
              )}>
              <Button
                color="primary"
                onClick={this.loadMore}
                className={styles.button}>
                Load more
              </Button>
            </div>
          )}
        {isLoading && this.state.loadingMore && loader}
      </React.Fragment>
    );
  }
}

export default LoadMoreView;
